(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  /* Market pill + localization sheet (native modal <dialog>: focus trap, Escape). The sheet opens over
     a dimmed page and locks its scrolling; a click on the dimmed page (pressed and released there) or
     the close button closes it, the focus goes back to the pill and an unsaved choice is reset.
     "Continue" submits the localization form (country + language). */
  if (!customElements.get('localization-sheet')) {
    class LocalizationSheet extends HTMLElement {
      connectedCallback() {
        this.opener = this.querySelector('.footer-market');
        this.dialog = this.querySelector('dialog');
        this.form = this.dialog && this.dialog.querySelector('form');
        if (!this.opener || !this.dialog) return;
        this.opener.addEventListener('click', () => this.open());
        // a click on the backdrop targets the dialog element itself: it closes the sheet only when the
        // pointer was both pressed and released outside the sheet (not a drag in or out of it)
        this.dialog.addEventListener('pointerdown', (event) => {
          this.pressedOutside = event.target === this.dialog;
        });
        this.dialog.addEventListener('pointerup', (event) => {
          this.releasedOutside = event.target === this.dialog;
        });
        this.dialog.addEventListener('click', (event) => {
          const outside = event.target === this.dialog && this.pressedOutside && this.releasedOutside && event.detail <= 1;
          this.pressedOutside = false;
          this.releasedOutside = false;
          if (outside || event.target.closest('[data-localization-sheet-close]')) this.close();
        });
        this.dialog.addEventListener('close', () => this.onClose());
        this.dialog.addEventListener('submit', () => {
          this.submitted = true;
          this.close();
        });
      }

      open() {
        if (this.dialog.open) return;
        this.submitted = false;
        this.dialog.showModal();
        this.opener.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden');
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      onClose() {
        // the close event is queued: a sheet opened again before it is delivered (same task) keeps its
        // scroll lock, its expanded state and its form
        if (this.dialog.open) return;
        if (!this.submitted && this.form) this.form.reset();
        this.opener.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('overflow-hidden');
        this.opener.focus();
      }
    }

    customElements.define('localization-sheet', LocalizationSheet);
  }

  /* Footer contact options with a popup (blocks/_contact-email, _contact-phone): on desktop devices
     (from 750px, with a mouse) a click, Enter or Space on the row opens its <dialog> (centred, page
     blurred behind it and not scrollable) instead of following the mailto: / tel: link, which still runs
     directly on touch devices and small screens. The popup shows the row's opening hours; Escape, the
     close button or a click outside (pressed and released outside) closes it with a short fade, and the
     focus goes back to the row. */
  if (!window.footerContactPopups) {
    window.footerContactPopups = true;
    const popupMode = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const rows = () => document.querySelectorAll('.footer .contact-item[data-contact-popup]');
    const syncRows = () => {
      rows().forEach((row) => {
        const dialog = document.getElementById(row.dataset.contactPopup);
        if (popupMode.matches && dialog) {
          row.setAttribute('role', 'button');
          row.setAttribute('aria-haspopup', 'dialog');
          row.setAttribute('aria-controls', dialog.id);
        } else {
          row.removeAttribute('role');
          row.removeAttribute('aria-haspopup');
          row.removeAttribute('aria-controls');
        }
      });
    };
    popupMode.addEventListener('change', syncRows);
    document.addEventListener('DOMContentLoaded', syncRows);
    document.addEventListener('shopify:section:load', syncRows);
    syncRows();

    const openPopup = (row) => {
      const dialog = document.getElementById(row.dataset.contactPopup);
      if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return false;
      const hours = dialog.querySelector('[data-contact-popup-hours]');
      const rowHours = row.querySelector('.contact-item__extra-info .contact-item__description');
      if (hours && rowHours) {
        hours.textContent = rowHours.textContent.trim();
        hours.hidden = hours.textContent === '';
      }
      endClose(dialog); // a new opening ends any fade-out still pending
      dialog.returnFocusTo = row;
      dialog.showModal();
      document.body.classList.add('overflow-hidden');
      return true;
    };
    // closes after the 0.3s fade-out (the dialog stays modal only while it is visible). The fade starts
    // from the popup's current opacity and size, so closing it while it is still opening does not flash it.
    // A close forced by the browser meanwhile (e.g. a second Escape) ends the pending fade, so its fallback
    // timer can never close a popup opened again right after.
    const pendingCloses = new WeakMap();
    const endClose = (dialog) => {
      const pending = pendingCloses.get(dialog);
      if (!pending) return;
      pendingCloses.delete(dialog);
      clearTimeout(pending.timer);
      dialog.removeEventListener('animationend', pending.onEnd);
      dialog.removeEventListener('close', pending.finish);
      dialog.classList.remove('is-closing');
      dialog.style.removeProperty('--fc-from');
      dialog.style.removeProperty('transform');
    };
    const closePopup = (dialog) => {
      if (!dialog.open || pendingCloses.has(dialog)) return;
      if (reducedMotion.matches) {
        dialog.close();
        return;
      }
      const current = getComputedStyle(dialog);
      const pending = {};
      pending.finish = () => {
        endClose(dialog);
        if (dialog.open) dialog.close();
      };
      pending.onEnd = (event) => {
        if (event.target === dialog && event.animationName === 'fc-popup-fade-out') pending.finish();
      };
      pending.timer = setTimeout(pending.finish, 350);
      pendingCloses.set(dialog, pending);
      dialog.addEventListener('animationend', pending.onEnd);
      dialog.addEventListener('close', pending.finish);
      dialog.style.setProperty('--fc-from', current.opacity);
      if (current.transform !== 'none') dialog.style.transform = current.transform;
      dialog.classList.add('is-closing');
    };

    // a click outside the popup (on its backdrop) closes it only when the pointer was both pressed and
    // released outside the popup box, and not as the second click of a double-click
    const outsidePopup = (event) => Boolean(event.target.classList && event.target.classList.contains('contact-popup'));
    let pressedOutside = false;
    let releasedOutside = false;
    document.addEventListener('pointerdown', (event) => {
      pressedOutside = outsidePopup(event);
    });
    document.addEventListener('pointerup', (event) => {
      releasedOutside = outsidePopup(event);
    });
    document.addEventListener('click', (event) => {
      const row = event.target.closest && event.target.closest('.footer .contact-item[data-contact-popup]');
      if (row) {
        if (popupMode.matches && openPopup(row)) event.preventDefault();
        return;
      }
      const dialog = event.target.closest && event.target.closest('.contact-popup');
      if (!dialog) return;
      const outside = event.target === dialog && pressedOutside && releasedOutside && event.detail <= 1;
      pressedOutside = false;
      releasedOutside = false;
      if (outside || event.target.closest('[data-contact-popup-close]')) closePopup(dialog);
    });
    // Space activates the row like a button (Enter already clicks the link)
    document.addEventListener('keydown', (event) => {
      if (event.key !== ' ' || !popupMode.matches) return;
      const row = event.target.closest && event.target.closest('.footer .contact-item[data-contact-popup]');
      if (row) event.preventDefault();
    });
    document.addEventListener('keyup', (event) => {
      if (event.key !== ' ' || !popupMode.matches) return;
      const row = event.target.closest && event.target.closest('.footer .contact-item[data-contact-popup]');
      if (row) {
        event.preventDefault();
        openPopup(row);
      }
    });
    // Escape: same fade as the other ways of closing
    document.addEventListener(
      'cancel',
      (event) => {
        const dialog = event.target;
        if (dialog.classList && dialog.classList.contains('contact-popup')) {
          event.preventDefault();
          closePopup(dialog);
        }
      },
      true
    );
    document.addEventListener(
      'close',
      (event) => {
        const dialog = event.target;
        if (!dialog.classList || !dialog.classList.contains('contact-popup')) return;
        // the close event is queued: a popup opened again before it is delivered (same task) keeps its
        // scroll lock and its way back to the row
        if (dialog.open) return;
        document.body.classList.remove('overflow-hidden');
        if (dialog.returnFocusTo) {
          dialog.returnFocusTo.focus();
          dialog.returnFocusTo = null;
        }
      },
      true
    );
  }

  /* Footer columns rendered with `collapsible` (snippets/footer-block-column): accordion rows on
     mobile, always open from 750px. The markup is open by default, so without JavaScript every
     column stays readable. */
  if (!customElements.get('footer-accordion')) {
    class FooterAccordion extends HTMLElement {
      constructor() {
        super();
        this.desktop = window.matchMedia('(min-width: 750px)');
        this.onMediaChange = this.sync.bind(this);
        this.onSummaryClick = this.onSummaryClick.bind(this);
      }

      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.details && this.details.querySelector('summary');
        if (!this.summary) return;
        this.summary.addEventListener('click', this.onSummaryClick);
        this.desktop.addEventListener('change', this.onMediaChange);
        this.sync();
      }

      disconnectedCallback() {
        if (this.summary) this.summary.removeEventListener('click', this.onSummaryClick);
        this.desktop.removeEventListener('change', this.onMediaChange);
      }

      onSummaryClick(event) {
        if (this.desktop.matches) event.preventDefault();
      }

      sync() {
        if (this.desktop.matches) {
          this.details.open = true;
          this.summary.setAttribute('tabindex', '-1');
          return;
        }
        this.summary.removeAttribute('tabindex');
        // a newsletter that was just submitted keeps its error / success message visible
        this.details.open = Boolean(this.querySelector('.form__message'));
      }
    }

    customElements.define('footer-accordion', FooterAccordion);

    document.addEventListener('shopify:block:select', (event) => {
      const accordion = event.target.querySelector && event.target.querySelector('footer-accordion details');
      if (accordion) accordion.open = true;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    #abortController = new AbortController();

    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      const signal = this.#abortController.signal;
      // matchMedia returns a MediaQueryList (an EventTarget), so it supports
      // the `signal` option. Without it the listener leaks: matchMedia is a
      // global persistent object, so the handler outlives the element.
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this), { signal });
      // the bar also changes height without crossing 990px (a Dropdown / Mega menu wrapping onto more rows):
      // keep --header-height in step with it
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.resizeObserver.observe(this.header);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp, { signal });
      window.addEventListener('shopify:section:load', this.onScrollHandler, { signal });
      window.addEventListener('scroll', this.onScrollHandler, { signal });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.#abortController.abort();
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    /* The bar over the media at the top of the page: a hero or the product page's gallery (on phones) whose own
       "transparent header" setting pulls it up under the bar (negative top margin). The bar stays transparent
       until that media has scrolled out: a hero (and a ticker right under it) once its bottom has passed the
       top of the window, the gallery once less than a tenth of it is left in the window. Returns null without
       such a media: the bar turns solid past its own height, as before.
       The bar's title (.header__bar-title, .scrolled-past-title): product pages once the gallery has scrolled
       out (transparent bar or not); pages with the "Help page" layout as soon as the page is scrolled (the Help
       section's own html.help-page-scrolled, CSS); other pages, policies, blog, article, collections list and
       404 once the page's own title (its first visible h1, else the heading of its first section) has passed
       under the bar, again hidden when it comes back; never where the bar hosts tabs (cart, favourites). The
       text is the one of that h1 (the Liquid title otherwise). */
    mediaScrolledOut() {
      const galleryOut = (gallery) => {
        const box = gallery.getBoundingClientRect();
        return box.bottom < box.height * 0.1;
      };
      const title = this.header.querySelector('.header__bar-title');
      if (title) {
        let past = false;
        const shown = (element) => {
          const box = element.getBoundingClientRect();
          return box.width > 1 && box.height > 1 && getComputedStyle(element).visibility !== 'hidden';
        };
        const sync = (heading) => {
          const text = heading && heading.tagName === 'H1' ? heading.textContent.trim() : '';
          if (text && title.textContent !== text) title.textContent = text;
        };
        if (title.dataset.barTitle === 'product') {
          const product = document.querySelector('#MainContent [id^="MainProduct-"]');
          past = !!product && galleryOut(product.querySelector('media-gallery') || product);
        } else if (!document.querySelector('.rd-wishlist__tabs, cart-items .cart-tabs')) {
          const help = document.querySelector('#MainContent h1.help-page-title');
          if (help) {
            // Help pages: the text of the page's own title (several Help sections can print one: the first is the
            // one shown), shown while the page is scrolled (html.help-page-scrolled, CSS)
            sync(help);
          } else {
            // the page's own title: its first visible h1, else the heading of its first section
            const heading = Array.from(document.querySelectorAll('#MainContent h1')).find(shown)
              || Array.from(document.querySelectorAll('#MainContent > .shopify-section:first-child :is(h1, h2)')).find(shown);
            if (heading) {
              sync(heading);
              past = heading.getBoundingClientRect().bottom < this.header.getBoundingClientRect().bottom;
            }
          }
        }
        this.header.classList.toggle('scrolled-past-title', past);
      }
      const first = document.querySelector('#MainContent > .shopify-section');
      const pulled = first && first.querySelector('.hero, [id^="MainProduct-"]');
      if (!pulled || !(parseFloat(getComputedStyle(pulled).marginTop) < 0)) return null;
      if (pulled.matches('.hero')) {
        const next = first.nextElementSibling;
        const end = next && next.querySelector('.horizontal-ticker') ? next : first;
        return end.getBoundingClientRect().bottom <= 0;
      }
      return galleryOut(pulled.querySelector('media-gallery') || pulled);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // home: the outlined search field under the transparent bar gives way to the bar's search icon
      this.header.classList.toggle('header-search-icon-in', scrollTop >= 150);
      this.header.classList.toggle('header-search-field-out', scrollTop >= 160);
      const media = this.mediaScrolledOut();
      if (media !== null && scrollTop > this.headerBounds.top) this.header.classList.toggle('scrolled-past-header', media);

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (media === null) this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (media === null) this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    #abortController = new AbortController();

    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      // See StickyHeader: signal-tied so the global matchMedia listener
      // releases when the element disconnects.
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this), { signal: this.#abortController.signal });
      // See StickyHeader: the bar can change height without crossing 990px
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.resizeObserver.observe(this.header);
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.#abortController.abort();
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }
  }

  customElements.define('static-header', StaticHeader);

  /* Header shortcuts (header tabs, menu drawer, search layer):
     - desktop tabs (header with tabs and the drawer menu type): hovering a tab with a mouse opens the menu
       drawer, leaving the tabs and the drawer closes it again; each tab carries a small button that appears on
       keyboard focus ([data-header-menu-toggle]) and opens / closes the drawer, focus then goes to the drawer
       and comes back to that button when it closes. The drawer <summary> leaves the tab order there, except on
       touch screens (no hover), where it stays in the bar as the menu icon.
     - [data-header-search-open]  search field of the menu drawer: the drawer closes itself (every drawer
                                  button closes its <details>), then the header search layer opens
     - [data-header-cart-link]    bag of the menu drawer: opens the cart drawer when there is one
     - [data-header-back]         "Fermer" of the search results page, "←" of product pages: back to the
                                  previous page of the shop (the link's own page when there is no history)
     - [data-header-product-back] product pages: shown in place of the menu icon (phones, .header--back) only
                                  when the visitor came from another page of the shop (same-origin referrer)
     - search layer: accessible name of its toggle follows the visible label, recommended products are
       created from their <template> the first time the layer opens
     - --rd-sbw: scrollbar width, so the bar items keep their place while a layer locks the page scroll */
  (() => {
    if (window.headerShortcutsBound) return;
    window.headerShortcutsBound = true;

    const desktop = window.matchMedia('(min-width: 990px)');
    const hover = window.matchMedia('(hover: hover)');
    const root = document.documentElement;
    // the page the visitor came from, when it is a page of the shop (null after a first landing)
    const shopReferrer = () => {
      try {
        const from = document.referrer ? new URL(document.referrer) : null;
        return from && from.origin === location.origin ? from : null;
      } catch (error) {
        return null;
      }
    };
    const productBack = () => {
      const back = document.querySelector('[data-header-product-back]');
      if (!back) return;
      const from = shopReferrer();
      const inShop = !!from && from.pathname !== location.pathname;
      back.closest('.header').classList.toggle('header--back', inShop);
      if (inShop) back.href = from.href;
    };
    const drawerDetails = () => document.getElementById('Details-menu-drawer-container');
    const menuSummary = () => document.querySelector('#Details-menu-drawer-container > summary');
    const tabsDriveDrawer = () => !!document.querySelector('.section-header .header.drawer-menu.header--has-tabs [data-header-menu-toggle]');
    const drawerOpen = () => {
      const details = drawerDetails();
      return !!(details && details.hasAttribute('open') && details.classList.contains('menu-opening'));
    };
    // move the focus into the opening drawer: an element of it only takes the focus once the drawer is shown (its
    // visibility follows the first frame of the opening transition, late on a busy device), so try again on the next
    // frames, for up to a second, while the drawer stays open; pick() returns null when there is nothing to focus
    const focusInDrawer = (pick) => {
      const start = performance.now();
      const attempt = () => {
        const details = drawerDetails();
        if (!details || !details.hasAttribute('open') || performance.now() - start > 1000) return;
        if (drawerOpen()) {
          const target = pick();
          if (!target) return;
          target.focus();
          if (document.activeElement === target) return;
        }
        requestAnimationFrame(attempt);
      };
      setTimeout(attempt, 60);
    };
    let programmatic = false;
    const toggleDrawer = () => {
      const summary = menuSummary();
      if (!summary) return;
      programmatic = true;
      try {
        summary.click();
      } finally {
        programmatic = false;
      }
    };
    /* mouse paths (hover): the theme focuses the menu <summary> when it opens / closes the drawer; there the keyboard
       focus must not move at all (a field would blur and send "change"): the summary's focus() does nothing meanwhile */
    const toggleDrawerQuietly = () => {
      const summary = menuSummary();
      if (!summary) return;
      summary.focus = () => {};
      try {
        toggleDrawer();
      } finally {
        delete summary.focus;
      }
    };

    let openedFrom = null;
    let openedByHover = false;
    let hoverFocus = null;
    let hoverTimer = 0;
    let leaveTimer = 0;

    /* touch screens (no hover) keep the menu icon in the bar: it stays in the tab order there, and the hidden
       arrow buttons of the tabs leave it */
    const syncSummaryFocus = () => {
      const touchDesktop = desktop.matches && !hover.matches;
      document.querySelectorAll('[data-header-menu-toggle]').forEach((button) => {
        if (touchDesktop) button.setAttribute('tabindex', '-1');
        else button.removeAttribute('tabindex');
      });
      const summary = menuSummary();
      if (!summary) return;
      if (desktop.matches && hover.matches && tabsDriveDrawer()) summary.setAttribute('tabindex', '-1');
      else summary.removeAttribute('tabindex');
    };

    /* a drawer opened (or closed) by the mouse must not move the keyboard focus: the theme focuses the menu
       <summary> on open / close, so the focus goes back to where it was (text typed in a field stays there) */
    const keepHoverFocus = (saved) => {
      requestAnimationFrame(() => {
        const summary = menuSummary();
        if (!summary || document.activeElement !== summary) return;
        if (saved && saved.isConnected && saved !== summary) saved.focus({ preventScroll: true });
        else summary.blur();
      });
    };

    /* the theme leaves the toggle's aria-expanded at "true" when Escape (or a script) closes the drawer, and
       its fixed ::before (the backdrop) then stays over the page: reset it on every close */
    const watchDrawerClose = (details) => {
      const observer = new MutationObserver(() => {
        if (details.classList.contains('menu-opening')) return;
        observer.disconnect();
        const summary = details.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
        document.querySelectorAll('[data-header-menu-toggle]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
        const back = openedFrom;
        const hovered = openedByHover;
        const saved = hoverFocus;
        openedFrom = null;
        openedByHover = false;
        hoverFocus = null;
        if (hovered) keepHoverFocus(saved);
        else if (back && back.isConnected) requestAnimationFrame(() => back.focus());
      });
      observer.observe(details, { attributes: true, attributeFilter: ['class', 'open'] });
    };

    const createRecommendations = (details) => {
      details.querySelectorAll('template.search-modal__lazy').forEach((template) => {
        template.replaceWith(document.importNode(template.content, true));
      });
    };

    const measureScrollbar = () => {
      const locked = document.body && (document.body.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden-sticky'));
      if (!locked) root.style.setProperty('--rd-sbw', Math.max(0, window.innerWidth - root.clientWidth) + 'px');
    };

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const toggle = target.closest('[data-header-menu-toggle]');
      if (toggle) {
        event.preventDefault();
        clearTimeout(hoverTimer);
        clearTimeout(leaveTimer);
        openedByHover = false;
        hoverFocus = null;
        openedFrom = toggle;
        if (drawerOpen()) {
          toggleDrawer();
          return;
        }
        toggleDrawer();
        focusInDrawer(() => document.querySelector('#menu-drawer .menu-drawer__search-bar--top .menu-drawer__search, #menu-drawer .menu-drawer__menu-item'));
        return;
      }

      if (target.closest('[data-header-search-open]')) {
        event.preventDefault();
        const drawer = drawerDetails();
        if (drawer && drawer.hasAttribute('open')) {
          const close = drawer.querySelector('.menu-drawer__close-btn');
          if (close && drawer.classList.contains('menu-opening')) close.click();
        }
        openedFrom = null;
        const searchSummary = document.querySelector('.header__icons details-modal.header__search summary');
        const searchDetails = searchSummary && searchSummary.closest('details');
        if (searchSummary && !searchDetails.hasAttribute('open')) searchSummary.click();
        return;
      }

      const cartLink = target.closest('[data-header-cart-link]');
      if (cartLink && document.querySelector('cart-drawer')) {
        const cartIcon = document.getElementById('cart-icon-bubble');
        if (!cartIcon) return;
        event.preventDefault();
        const drawer = drawerDetails();
        const close = drawer && drawer.querySelector('.menu-drawer__close-btn');
        if (close && drawer.hasAttribute('open')) close.click();
        cartIcon.click();
        return;
      }

      const back = target.closest('[data-header-back]');
      if (back && shopReferrer() && history.length > 1) {
        event.preventDefault();
        history.back();
      }
    });

    /* mouse: hover a tab to open the drawer, leave the tabs and the drawer to close it */
    const hoverZone = (element) => !!(element && (element.closest('.header-tabs--header .header-tabs__item') || element.closest('#menu-drawer')));
    document.addEventListener('pointerover', (event) => {
      if (event.pointerType !== 'mouse' || !desktop.matches || !tabsDriveDrawer()) return;
      const target = event.target instanceof Element ? event.target : null;
      if (!hoverZone(target)) return;
      clearTimeout(leaveTimer);
      if (target.closest('.header-tabs--header .header-tabs__item') && !drawerOpen()) {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => {
          if (drawerOpen() || document.querySelector('.header__icons details-modal.header__search > details[open]')) return;
          openedByHover = true;
          openedFrom = null;
          hoverFocus = document.activeElement !== document.body ? document.activeElement : null;
          toggleDrawerQuietly();
          keepHoverFocus(hoverFocus);
        }, 150);
      }
    });
    /* Escape closes a drawer opened by the mouse even though the keyboard focus stayed in the page (the theme
       only listens inside the drawer) */
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !openedByHover || !drawerOpen()) return;
      const target = event.target instanceof Element ? event.target : null;
      if (target && target.closest('#Details-menu-drawer-container')) return;
      clearTimeout(leaveTimer);
      toggleDrawerQuietly();
    });
    document.addEventListener('pointerout', (event) => {
      if (event.pointerType !== 'mouse' || !desktop.matches || !tabsDriveDrawer()) return;
      const from = event.target instanceof Element ? event.target : null;
      const to = event.relatedTarget instanceof Element ? event.relatedTarget : null;
      if (!hoverZone(from) || hoverZone(to)) return;
      clearTimeout(hoverTimer);
      if (drawerOpen() && openedByHover) {
        clearTimeout(leaveTimer);
        leaveTimer = setTimeout(() => {
          if (drawerOpen() && openedByHover) toggleDrawerQuietly();
        }, 300);
      }
    });

    /* phones / tablets: a menu opened with the keyboard gives the focus to its ✕ (the bar's menu icon is under the
       menu's own top bar). A keyboard press on the summary is a click with detail 0 (not one of the script's). */
    let keyboardOpen = false;
    document.addEventListener('click', (event) => {
      const summary = event.target instanceof Element ? event.target.closest('#Details-menu-drawer-container > summary') : null;
      if (summary) keyboardOpen = !programmatic && event.detail === 0 && !summary.parentElement.hasAttribute('open');
    }, true);

    /* open / close of the drawer and the search layer (toggle does not bubble: capture) */
    document.addEventListener('toggle', (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;
      if (details.id === 'Details-menu-drawer-container') {
        document.querySelectorAll('[data-header-menu-toggle]').forEach((button) => button.setAttribute('aria-expanded', details.open ? 'true' : 'false'));
        if (details.open) {
          watchDrawerClose(details);
          if (keyboardOpen) {
            keyboardOpen = false;
            // (desktop: no ✕, display none)
            focusInDrawer(() => {
              const close = details.querySelector('.menu-drawer__close-btn');
              return close && close.getClientRects().length ? close : null;
            });
          }
        }
        return;
      }
      if (details.parentElement && details.parentElement.matches('details-modal.header__search')) {
        const summary = details.querySelector(':scope > summary');
        if (summary && summary.dataset.labelOpen) summary.setAttribute('aria-label', details.open ? summary.dataset.labelOpen : summary.dataset.labelClosed);
        if (details.open) createRecommendations(details);
      }
    }, true);

    /* typed suggestions (sections/predictive-search.liquid): the theme closes them as soon as the focus leaves the
       search field and its rows. In the search layer they stay while the focus is anywhere in the open layer
       ("FERMER", "ANNULER" included); they close with the layer. */
    if (window.customElements) {
      customElements.whenDefined('predictive-search').then(() => {
        const proto = customElements.get('predictive-search').prototype;
        if (proto.rdLayerAware || typeof proto.close !== 'function') return;
        proto.rdLayerAware = true;
        const close = proto.close;
        proto.close = function (clearSearchTerm) {
          const active = document.activeElement;
          if (!clearSearchTerm && active && active.closest) {
            const layer = this.closest('details-modal.header__search > details[open]');
            if (layer && layer.contains(active)) return;
          }
          return close.call(this, clearSearchTerm);
        };
      });
    }

    /* the open search layer and the open menu are modal (the page is locked): Tab / Shift+Tab cycle through what
       they show. Search layer: the bar's toggle while it stays visible ("FERMER" on desktop), the field and its
       buttons, the suggestions or the results, "ANNULER" on phones. Menu: the tab arrow that opened it (desktop),
       the menu icon while it stays visible (touch screens), then the menu; never the menu icon under the phone
       menu. The theme's traps keep the first / last elements found when they opened (hidden ones included): the
       focus could leave for the page under them. A quick add popup, the cart drawer or another modal <dialog>
       keeps its own focus. */
    const TABBABLE = 'summary, a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]';
    const tabbable = (element) => element.tabIndex >= 0 && !element.disabled && !element.closest('[inert]')
      && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    const uncovered = (element) => {
      const r = element.getBoundingClientRect();
      const hit = document.elementFromPoint(r.x + r.width / 2, r.y + r.height / 2);
      return !!hit && element.contains(hit);
    };
    const otherModalOpen = () => {
      if (document.querySelector('quick-add-modal[open], cart-drawer.active')) return true;
      try {
        return !!document.querySelector('dialog:modal');
      } catch (error) {
        return !!document.querySelector('dialog[open]');
      }
    };
    const cycleFocus = (event, items, focused) => {
      if (!items.length) return;
      event.preventDefault();
      event.stopPropagation();
      const step = event.shiftKey ? -1 : 1;
      let index = items.indexOf(focused);
      if (index === -1) {
        // the focus is on something outside the cycle (the layer or the menu itself): go on from its place
        const after = focused ? items.findIndex((item) => focused.compareDocumentPosition(item) & Node.DOCUMENT_POSITION_FOLLOWING) : -1;
        if (after === -1) index = event.shiftKey ? items.length : -1;
        else index = event.shiftKey ? after : after - 1;
      }
      items[(index + step + items.length) % items.length].focus();
    };
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || event.altKey || event.ctrlKey || event.metaKey) return;
      if (otherModalOpen()) return;
      const active = document.activeElement;
      const focused = active && active !== document.body ? active : null;
      const drawer = drawerDetails();
      if (drawer && drawerOpen()) {
        const panel = document.getElementById('menu-drawer');
        // a menu opened by the mouse leaves the keyboard focus in the page
        if (!panel || (focused && !drawer.contains(focused) && focused !== openedFrom)) return;
        const items = [...panel.querySelectorAll(TABBABLE)].filter(tabbable);
        const summary = menuSummary();
        if (summary && tabbable(summary) && uncovered(summary)) items.unshift(summary);
        if (openedFrom && openedFrom.isConnected && tabbable(openedFrom)) items.unshift(openedFrom);
        cycleFocus(event, items, focused);
        return;
      }
      const details = document.querySelector('details-modal.header__search > details[open]');
      if (!details) return;
      if (focused && !details.contains(focused)) return;   // another dialog / drawer has the focus
      const layer = details.querySelector('.search-modal');
      if (!layer) return;
      const items = [...layer.querySelectorAll(TABBABLE)].filter(tabbable);
      const toggle = details.querySelector(':scope > summary');
      if (toggle && tabbable(toggle) && uncovered(toggle)) items.unshift(toggle);
      cycleFocus(event, items, focused);
    }, true);

    /* typed suggestions: Tab reaches the rows (links) and the arrow keys still move through them from the field.
       The focused row is the selected option too (aria-selected: the ring), the arrow keys go on from it (the
       focus follows), and Enter acts once (on the focused link, not on the selection).
       The chips row of the phone layer scrolls a focused edge chip fully into view. */
    document.addEventListener('focusin', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      if (target.matches('.section-header .search-modal__chip')) target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      const search = target.closest('predictive-search');
      if (!search || target === search.input || !target.matches('.predictive-search__item')) return;
      const option = target.closest('[role="option"]');
      if (!option) return;
      search.querySelectorAll('[aria-selected="true"]').forEach((selected) => {
        if (selected !== option) selected.setAttribute('aria-selected', 'false');
      });
      option.setAttribute('aria-selected', 'true');
      if (search.input && option.id) search.input.setAttribute('aria-activedescendant', option.id);
    });
    document.addEventListener('keyup', (event) => {
      if (event.key !== 'Enter') return;
      const target = event.target instanceof Element ? event.target : null;
      const search = target && target.closest('predictive-search');
      if (search && target !== search.input) event.stopPropagation();
    }, true);
    document.addEventListener('keyup', (event) => {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const target = event.target instanceof Element ? event.target : null;
      const search = target && target.closest('predictive-search');
      if (!search || target === search.input) return;
      const selected = search.querySelector('[aria-selected="true"]');
      const item = selected && (selected.matches('.predictive-search__item') ? selected : selected.querySelector('.predictive-search__item'));
      if (item && item !== document.activeElement && tabbable(item)) item.focus();
    });

    /* add to cart from a quick add popup of the search layer (its recommended products) opens the cart drawer (a
       modal <dialog>): when it closes while the layer is still open, the layer gets its scroll lock back and the
       focus goes back into it (the bag that was pressed, or the field) */
    let layerBag = null;
    document.addEventListener('click', (event) => {
      const bag = event.target instanceof Element ? event.target.closest('.quick-add__submit') : null;
      if (bag && bag.closest('details-modal.header__search > details[open]')) layerBag = bag;
    }, true);
    document.addEventListener('close', (event) => {
      if (!(event.target instanceof HTMLDialogElement) || !event.target.closest('cart-drawer')) return;
      const details = document.querySelector('details-modal.header__search > details[open]');
      if (!details) return;
      document.body.classList.add('overflow-hidden-sticky');
      const active = document.activeElement;
      if (active && active !== document.body && details.contains(active)) return;
      const back = layerBag && layerBag.isConnected && tabbable(layerBag) ? layerBag : details.querySelector('input[type="search"]');
      if (back) back.focus();
    }, true);

    const setup = () => {
      syncSummaryFocus();
      measureScrollbar();
      productBack();
    };
    desktop.addEventListener('change', syncSummaryFocus);
    hover.addEventListener('change', syncSummaryFocus);
    window.addEventListener('resize', measureScrollbar);
    document.addEventListener('shopify:section:load', setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
    else setup();
  })();

  } catch(e) { console.error(e); }
})();
})();
